import { Dispatch, FC, SetStateAction } from 'react';
import { Nav } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { Menu } from 'src/models/Menu.model';

import * as CONSTANT from '../../../constants';
import { brazeLogCustomEventViewPage } from 'src/helper/brazeHelper';
import useCheckMobileScreen from 'src/hooks/useCheckMobileScreen';
interface NavProps {
  menus: Menu[];
  setIsSearching?: Dispatch<SetStateAction<boolean>>;
  clearSearch?: () => void;
  isSearching?: boolean;
}

const NavItems: FC<NavProps> = (props) => {
  const { menus, clearSearch, setIsSearching, isSearching } = props;
  const history = useHistory();
  const isItMobile = useCheckMobileScreen();

  const MenuLinksHandler = (menu) => {
    history.replace(`${CONSTANT.ROUTE_MENU}/${menu.name}`, {
      showCustomization: false,
    });
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    if (isSearching) {
      clearSearch();
    }
    brazeLogCustomEventViewPage(`${menu?.name} Menu`, isItMobile);
    setIsSearching(false);
  };

  return (
    <>
      {menus.map((menu, i: number) => (
        <Nav.Item id={menu.name} key={i}>
          <Nav.Link eventKey={menu.name} onClick={() => MenuLinksHandler(menu)}>
            {menu.name}
          </Nav.Link>
        </Nav.Item>
      ))}
    </>
  );
};

export default NavItems;
